{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://schemas.fortemi.dev/knowledge-shard/1.0.0/core-v1/template.schema.json",
  "title": "Fortemi Knowledge Shard core-v1 template record",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "id",
    "name",
    "description",
    "content",
    "format",
    "default_tags",
    "collection_id",
    "created_at",
    "updated_at"
  ],
  "properties": {
    "id": {
      "$ref": "#/$defs/uuid"
    },
    "name": {
      "type": "string",
      "minLength": 1
    },
    "description": {
      "type": ["string", "null"]
    },
    "content": {
      "type": "string"
    },
    "format": {
      "type": "string",
      "minLength": 1
    },
    "default_tags": {
      "type": "array",
      "uniqueItems": true,
      "items": {
        "type": "string",
        "minLength": 1
      }
    },
    "collection_id": {
      "oneOf": [
        {
          "$ref": "#/$defs/uuid"
        },
        {
          "type": "null"
        }
      ]
    },
    "created_at": {
      "type": "string",
      "format": "date-time"
    },
    "updated_at": {
      "type": "string",
      "format": "date-time"
    }
  },
  "$defs": {
    "uuid": {
      "type": "string",
      "format": "uuid"
    }
  }
}
